import { useHistory } from 'react-router-dom';

import useHeaderTitle from '../../hooks/useHeaderTitle';
import PaymentFailed from './components/PaymentFailed';

import './PaymentFailedPage.less';

const PaymentFailedPage = () => {
	const history = useHistory();

	useHeaderTitle('金飯碗 Gold Rice Bowl', true);

	const handleRetry = () => {
		// Navigate back to booking page
		history.push('/booking');
	};

	return (
		<div className="payment-failed-container">
			<PaymentFailed onRetry={handleRetry} />
		</div>
	);
};

export default PaymentFailedPage;
